import { z } from "@/zod";
import { nonNegativeDecimalStringSchema, ulid } from "@/schemas/commonFields";
import { taxStatus } from "./commonFields/taxStatus";
import { applyEmptyStringsToNulls } from "@/lib/utils/zod";

export const payrollAggregate = z
  .object({
    id: ulid,
    payroll_id: ulid,
    period: z.string().date(),
    contractor_id: ulid,
    contractor: z.string(),
    personal_id_number: z.string(),
    tax_status_final: taxStatus,
    agreement_company_id: ulid,
    agreement_company: z.string(),
    aggregated_amount: nonNegativeDecimalStringSchema,
    deduction_percentage: nonNegativeDecimalStringSchema,
    administrative_fee: nonNegativeDecimalStringSchema,
    deduction: nonNegativeDecimalStringSchema,
    addition: nonNegativeDecimalStringSchema,
    amount_to_pay: nonNegativeDecimalStringSchema,
    comment: z.string(),
    permanent_comment: z.string(),
    student_id_valid_until: z.string(),
    is_employed: z.boolean(),
    is_student: z.boolean(),
    citizenship: z.string(),
  })
  .readonly();

export const updatePayrollAggregate = applyEmptyStringsToNulls({
  id: ulid,
  deduction_percentage: nonNegativeDecimalStringSchema.nullable(),
  administrative_fee: nonNegativeDecimalStringSchema.nullable(),
  deduction: nonNegativeDecimalStringSchema.nullable(),
  addition: nonNegativeDecimalStringSchema.nullable(),
  comment: z.coerce.string().max(250).nullable(),
});
